<template>
  <div>
    <el-alert
      title="İndirim Kaydı Yok"
      type="success"
      :closable="false"
      v-if="!Aktif">
    </el-alert>
    <el-table
      class="table-xs"
      style="width: 100%"
      width="100%"
      :data="data"
      v-if="Aktif"
      row-key="id"
      :height="Height">
      <el-table-column
        prop="Tanim"
        label="Tanım">
      </el-table-column>
      <el-table-column
        prop="Oran"
        label="Oran"
        width="100">
      </el-table-column>
      <el-table-column
        prop="Kategori"
        label="Kategori">
      </el-table-column>
      <el-table-column
        prop="basTarihiText"
        label="Başlama Tarihi"
        width="120">
      </el-table-column>
      <el-table-column
        prop="bitTarihiText"
        label="Bitiş Tarihi"
        width="120">
      </el-table-column>
    </el-table>
  </div>
</template>


<script>
export default {
  props: ["data", "Aktif"],
  data() {
    return {
      Liste: null,
      Height: window.innerHeight - 215
    }
  },
  methods: {},
  created() {
    this.SayfaYukle()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Yonetim/kisi/Ekran/KisiIndirim.vue